import {
  getBrowserData,
  getBuildTimeStamp,
  getTimeSincePageStart,
  getWindowDimensions,
  initConsoleLog,
  initLog,
  log,
  newGuid,
  OTelConfig,
  TagId,
} from '@ms-ows/logging'

import { ActionType, IPageContext } from '../models'

const initConsoleLogIfRequired = (pageContext: IPageContext) => {
  try {
    let enableConsoleLog = process.env.NODE_ENV === 'development'
    let logSettings = pageContext.logSettings

    // tslint:disable-next-line: strict-type-predicates
    if (!enableConsoleLog && typeof logSettings === 'string') {
      // logSettings is currently a string type.
      // the following code can be removed once the host params is fixed
      const settingStr = logSettings as string
      if (settingStr[0] === '{') {
        const settingsObj = JSON.parse(settingStr)

        // tslint:disable-next-line: no-unsafe-any
        logSettings = (settingsObj.content || settingsObj) as typeof logSettings
      }
    }

    if (!enableConsoleLog && logSettings) {
      enableConsoleLog = !!logSettings.consoleLog
    }

    if (enableConsoleLog) {
      initConsoleLog(true)
    }
  } catch (error) {
    // ignore error
    console.log('FG-OWS-OTEL invalid log options', pageContext, error)
  }
}

export const initTelemetry = (inputPageContext: IPageContext) => {
  const pageContext = inputPageContext || {}
  const telemetryConfig = process.env.OTEL_CONFIG as unknown as OTelConfig

  if (
    !telemetryConfig ||
    !telemetryConfig.ariaTenantToken ||
    !telemetryConfig.nexusTenantToken
  ) {
    console.log('FG-OWS-OTEL config not valid', telemetryConfig)
  }

  if (process.env.NODE_ENV === 'production' && telemetryConfig) {
    initLog(
      telemetryConfig,
      {
        customSessionId: pageContext.logSessionId || newGuid(),
      },
      pageContext.telemetrySink
    )
  }

  initConsoleLogIfRequired(pageContext)

  const telemetryGroup = pageContext.telemetryGroup || {}
  const commonFields = {
    hostAppId: pageContext.appId,
    hostBuild: pageContext.build,
    hostEnv: pageContext.env,
    hostLocale: pageContext.originalLocale,
    surfaceId: pageContext.surfaceId,

    hostAudience: telemetryGroup.audienceGroup,
    hostPlatform: telemetryGroup.platform,
  }

  // set common fields for all events
  log.updateCustomData(commonFields)

  log.event(0x2361a7dd /* tag_9y053 */, 'Init', {
    customData: {
      buildTime: getBuildTimeStamp(),

      // telemetry details
      hostFlights: telemetryGroup.flights,

      // page stats
      loadDelay: getTimeSincePageStart(),
      loadTime: pageContext.surfaceInitTime
        ? Date.now() - pageContext.surfaceInitTime
        : undefined,

      ...getBrowserData(),
      ...getWindowDimensions(),
    },
  })
}

export const logElapsedEvent = (
  tagId: TagId,
  event:
    | 'SurfaceCompleted'
    | 'SurfaceDismissed'
    | 'SurfaceFullRenderCompleted'
    | 'SurfaceUnload',
  button: ActionType,
  renderIndex: number,
  launchTime: number,
  surfaceId: string | undefined,
  itemCount = -1
) =>
  log.userActionEvent(tagId, event, {
    customData: {
      button,
      elapsedTime: Date.now() - launchTime,
      itemCount,
      renderIndex,
      surfaceId,
    },
  })
